module.exports = __webpack_public_path__ + "img/manda_037.209ad656.png";